import { render, staticRenderFns } from "./PackagesTable.vue?vue&type=template&id=7848e878&scoped=true"
import script from "./PackagesTable.vue?vue&type=script&lang=js"
export * from "./PackagesTable.vue?vue&type=script&lang=js"
import style0 from "./PackagesTable.vue?vue&type=style&index=0&id=7848e878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7848e878",
  null
  
)

export default component.exports